class tableAccessCode {
  constructor(cat, name) {
    this.cat = cat;
    this.name = name;
  }

  static fromJson({ cat, nombre }) {
    return new tableAccessCode(cat, nombre);
  }
}

export default tableAccessCode;
